import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexRange',
  setup(__props) {

const defultRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/defultRang.vue"))
const minMax = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/minMax.vue"))
const prefixRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/prefixRang.vue"))
const negativeRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/negativeRang.vue"))
const stepsRange = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/stepsRange.vue"))
const customRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/customRang.vue"))
const colorRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/colorRang.vue"))
const prettifyRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/prettifyRang.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Range Slider"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(defultRang)),
        _createVNode(_unref(minMax)),
        _createVNode(_unref(prefixRang)),
        _createVNode(_unref(negativeRang)),
        _createVNode(_unref(stepsRange)),
        _createVNode(_unref(customRang)),
        _createVNode(_unref(prettifyRang)),
        _createVNode(_unref(colorRang))
      ])
    ])
  ], 64))
}
}

})